// Pathways.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import humanVerificationImage from '../assets/human-verification.png';
import travelServicesImage from '../assets/travel-services.png';

const Pathways = () => {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            Pathways
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          
          {/* Verification Services */}
          <motion.div 
            className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="mb-6">
              <img 
                src={humanVerificationImage} 
                alt="Verification Services" 
                className="w-44 h-44 object-contain mb-4"
              />
              <h3 className="text-2xl font-inter font-bold text-acBlack mb-4">
                Verification Services
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Identity & background checks, employment & education confirmation, address verification, 
                guarantor and corporate due diligence, and financial standing (bank letters, income & asset attestations).
              </p>
              <Link 
                to="/verification" 
                className="inline-flex items-center text-acYellow hover:text-green-700 font-semibold transition-colors"
              >
                → Explore Verification
              </Link>
            </div>
          </motion.div>

          {/* Travel & Immigration Assistance */}
          <motion.div 
            className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="mb-6">
              <img 
                src={travelServicesImage} 
                alt="Travel & Immigration Assistance" 
                className="w-28 h-28 object-contain mb-4"
              />
              <h3 className="text-2xl font-inter font-bold text-acBlack mb-4">
                Travel & Immigration Assistance
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Visa route advice, document checklists, background certificates, interview coaching, 
                application organization and quality control.
              </p>
              <Link 
                to="/travel" 
                className="inline-flex items-center text-acYellow hover:text-green-700 font-semibold transition-colors"
              >
                → Explore Travel
              </Link>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Pathways;
